import { render, staticRenderFns } from "./PrestacionesForm.vue?vue&type=template&id=45e2d113&"
import script from "./PrestacionesForm.vue?vue&type=script&lang=js&"
export * from "./PrestacionesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports